module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/lecco.a936903149458d30a76503a30495cac4.jpg";